import CityPageTemplate from "../city-template/CityPageTemplate";
import { bowlingGreenConfig } from "./data";

export default function BowlingGreenPage() {
  return <CityPageTemplate config={bowlingGreenConfig} />;
}